import { createRouter, createWebHistory } from 'vue-router';

import routes from './routes';
import { validateAccess, tracking } from './routerGuard';
import httpClient from '../modules/HttpClient';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(validateAccess);
router.afterEach((to, from, failure) => {
  tracking(to, from, failure);
  httpClient.cancelAllRequests();
});

export default router;
